module.exports = __webpack_public_path__ + "static/img/logo.8d814a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = BvKS
// module chunks = 1